import { useEffect } from "react";
import { useRouter } from "next/navigation";
export default function OAuthRedirectFix() {
    const router = useRouter();
    useEffect(() => {
        const url = new URL(window.location.href);
        if (url.searchParams.has("code")) {
            router.replace(window.location.pathname);
        }
        if (url.searchParams.has("error")) {
            router.replace(window.location.pathname);
        }
        if (url.searchParams.has("success")) {
            router.replace(window.location.pathname);
        }
    }, [router]);

    return null;
}
